import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PROJECT_APPLICATION } from 'gql/projectApplications';
import { GET_MY_ROLES_AND_CURRENT_USER_ROLE } from 'gql/auth';

const useIsCurrentEndorser = (id) => {
  const { data: meData, loading: meLoading } = useQuery(
    GET_MY_ROLES_AND_CURRENT_USER_ROLE
  );
  const { data, loading } = useQuery(GET_PROJECT_APPLICATION, {
    variables: { id },
  });
  const [result, setResult] = useState({
    loading: true,
    isCurrentEndorser: false,
  });

  useEffect(() => {
    if (loading || meLoading) {
      return setResult({
        loading: true,
        isCurrentEndorser: false,
      });
    }
    const projectApplication = data?.projectApplication;
    const me = meData?.me;
    const myCurrentUserRole = meData?.myCurrentUserRole;

    if (
      projectApplication?.currentEndorsementStep?.endorserListingType ===
      'ASSIGN'
    ) {
      return setResult({
        loading: false,
        isCurrentEndorser:
          projectApplication?.currentAppointedEndorser?.user?.id === me?.id,
      });
    }
    if (
      projectApplication?.currentEndorsementStep?.endorserListingType ===
      'HIERARCHY'
    ) {
      return setResult({
        loading: false,
        isCurrentEndorser:
          projectApplication?.currentAppointedEndorser?.role?.id ===
            myCurrentUserRole?.role?.id &&
          (projectApplication?.currentAppointedEndorser?.department
            ? projectApplication?.currentAppointedEndorser?.department?.id ===
              myCurrentUserRole?.department?.id
            : true) &&
          (projectApplication?.currentAppointedEndorser?.faculty
            ? projectApplication?.currentAppointedEndorser?.faculty?.id ===
              myCurrentUserRole?.faculty?.id
            : true),
      });
    }
  }, [loading, data, meLoading, meData]);

  return result;
};

export default useIsCurrentEndorser;
